<div fxLayout="column" fxLayoutAlign="center center center">
    <div ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;" style="margin-bottom: 120px; padding: 15px">

        <ng-container *ngIf="isLoading then showLoading else showAffirmation"></ng-container>
        <ng-template #showLoading>
            <app-loading></app-loading>
        </ng-template>
        <ng-template #showAffirmation>
          <div fxLayout="column">
            <quill-editor readOnly="readOnly" [modules]="{ toolbar: false }" [styles]="editorStylePreview"
                          [(ngModel)]="htmlContent"></quill-editor>

            <div>
            <table style="margin-top: 20px; padding-left: 15px; padding-right: 15px;">
                <tr>
                    <th colspan="2">
                        {{affirmation.title}}
                    </th>
                </tr>
                <tr>
                    <td>Ονοματεπώνυμο χρήστη:</td>
                    <td>
                        <mat-form-field *ngIf="mode !== 'display'" appearance="outline" style="width:100%;">
                            <label>
                                <input matInput [(ngModel)]="parentDisplayName" readonly />
                            </label>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>Ονοματεπώνυμο:</td>
                    <td>
                        <mat-form-field *ngIf="mode !== 'display'" appearance="outline" style="width:100%;">
                            <label>
                                <input matInput [(ngModel)]="childDisplayName" readonly />
                            </label>
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngIf="this.selectedActivity.assignedLevels && this.selectedActivity.assignedLevels.length > 0">
                    <td>Επίπεδο</td>
                    <td> <mat-form-field appearance="outline" style="width: 100%;" fxFlexAlign="center">
                        <mat-select fxFlexAlign="center" [(ngModel)]="selectedLevel">
                          <mat-option *ngFor="let level of selectedActivity.assignedLevels" [value]="level">{{level.description}}</mat-option>
                        </mat-select>
                    </mat-form-field></td>
                </tr>
                <tr *ngIf="affirmation.hasComments === 1">
                    <td>Περιοχή σχολίων</td>
                    <td><textarea [(ngModel)]="comments"></textarea> </td>
                </tr>
            </table>
            </div>

            <div *ngIf="mode !== 'display' && !showTwoFactor" style="width: 100%; margin-top: 20px;" fxLayoutAlign="center center center">
                <button mat-raised-button (click)="submitAffirmation()" style="background-color: var(--primary); color: white;">Εγγραφή</button>
            </div>

          <div *ngIf="showTwoFactor"
               fxFlex style="height: 80px; background-color: whitesmoke; padding: 5px; margin-top: 5px;">
            <div fxLayout="column" fxLayoutGap="5px">
            <span style="font-family: 'Century Gothic', sans-serif;">
              Πληκτρολογήστε τον 6ψήφιο κωδικό που σας έχει αποσταλεί
            </span>

              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">
                <mat-form-field appearance="legacy">
                  <mat-label>Κωδικός 2 βημάτων</mat-label>
                  <input matInput [(ngModel)]="code" />
                </mat-form-field>

                <button mat-raised-button class="stepperButton" [disabled]="!code || code.length < 6" (click)="validateCode()">Επαλήθευση</button>
                <button  (click)="requestCode()" mat-raised-button class="stepperButton">
                  Επαναποστολή κωδικού
                </button>
              </div>
            </div>
            </div>
          </div>
        </ng-template>

    </div>
</div>
